export const environment = {
    production: false,
    API_BASE_PATH: 'https://tracker-dev.j-call.ru/api',
    // API_BASE_PATH: 'http://localhost:3000/api',
};
